<template>
    <v-container
            id="booking-detail"
            fluid
            tag="section"
    >
        <v-row justify="center">
            <v-col
                    cols="12"
                    md="12"
            >
                <base-material-card color="primary">
                    <template v-slot:heading>

                        <v-row>
                            <v-col cols="11">
                                <div class="display-2 font-weight-light">
                                    {{sectionTitle}}
                                </div>
                                <div class="subtitle-1 font-weight-light">
                                    Complete the following details
                                </div>
                            </v-col>
                            <v-col cols="1">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-if="!isCreate" class="mx-1" fab dark color="red" small @click="toggleEdit()" v-on="on">
                                            <v-icon small>{{edit_icon}}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edit</span>
                                </v-tooltip>

                            </v-col>
                        </v-row>
                    </template>
                    <v-form ref="form"
                            v-model="valid"
                            lazy-validation >
                        <v-container class="py-0">
                            <v-row>
                                <dynamic-element :booking="booking" :form_content="form_content" :disabled="disabled"/>

                                <v-col
                                        v-if="!disabled"
                                        cols="12"
                                        class="text-right"
                                >
                                    <v-btn
                                            color="success"
                                            class="mr-4"
                                            @click="saveBooking()"
                                            :disabled="disabled || !valid"
                                    >
                                        Save Booking
                                    </v-btn>
                                    <v-btn
                                            color="error"
                                            class="mr-0"
                                            @click="toggleEdit()"
                                            :disabled="disabled"
                                    >
                                        Cancel
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-expansion-panels
                            v-if="!isCreate"
                            popout
                            hover
                            class="mb-8"
                    >
                        <v-expansion-panel
                                class="mt-1"
                                v-for="(item,i) in items"
                                :key="i"
                        >
                            <v-expansion-panel-header color="orange lighten-3">{{item.title}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <journey-resource v-if="item.action === 'journey'" :booking_id="booking.id"/>
                                <container-resource v-else-if="item.action === 'container'" :booking_id="booking.id"/>
                                <shipping-bill-resource v-else-if="item.action === 'shipping_bill'" :booking_id="booking.id"/>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <template v-slot:actions>
                        <v-row>
                            <v-col cols="6" md="6">
                                <v-icon
                                        class="mr-1"
                                        small
                                >
                                    mdi-clock-outline
                                </v-icon>
                                <span class="caption grey--text font-weight-light">{{`created on ${getDisplayDate(booking.created_at)}`}}</span>
                            </v-col>
                            <v-col cols="6" md="6">
                                <span class="caption grey--text font-weight-light float-right">{{booking.created_by}}</span>
                                <v-icon
                                        class="mr-1 float-right"
                                        small
                                >
                                    mdi-account
                                </v-icon>
                            </v-col>
                        </v-row>
                    </template>
                </base-material-card>
                <base-material-snackbar
                        v-model="snackbar"
                        :type="snackbar_color"
                        v-bind="{
        [direction[0]]: true,
        [direction[1]]: true
      }"
                >
                    {{snackbar_text}}
                </base-material-snackbar>
            </v-col>
        </v-row>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>

    import {mapState} from 'vuex'

    import BookingApi from "../../../api/booking_api"

    import {EQUIPMENT_TYPES} from '../../../modals/volume_equipment'

    import DateTimeHelper from '../../../helpers/datetime'

    import JourneyResource from '../components/resources/Journey'
    import ContainerResource from '../components/resources/Container'
    import ShippingBillResource from "../components/resources/ShippingBill"

    import DynamicElement from "../component/DynamicElement"
    import {BL_RELEASE_TYPE, BL_STATUS_OPTIONS} from "../../../modals/billOfLading_status.js";
    import { BOOKING_STATUS } from "../../../modals/enums/booking_status"

    export default {
        name: "BookingDetail",
        components: {JourneyResource, ContainerResource, ShippingBillResource, DynamicElement},
        data: () => ({
            dateTempHolder: {},
            valid: true,
            booking: {},
            overlay: true,
            edit_mode: false,
            edit_icon: 'create',
            snackbar: false,
            snackbar_color: 'error',
            snackbar_text: 'Saved Success somdg asd sda s',
            direction: ['bottom', 'center'],
            form_content: [
                {md: '6', id: 'id', label: 'Booking Number', type: 'text-field', required: true, validate: false, validateLength: false, counter: 10, customRules: []},//v => (v && v.length == 10) || 'Should be 10 character long'
                {md: '6', id: 'bill_of_lading', label: 'Bill of Lading #', type: 'text-field', required: false,  validateLength: false, counter: 10 },
                {md: '6', id: 'bol_status', label: 'B/L Status', type: 'select',items: BL_STATUS_OPTIONS, required: false },
                {md: '3', id: 'bol_type', label: 'B/L Type', type: 'select',items: BL_RELEASE_TYPE, required: false },
                {md: '3', id: 'bol_date', label: 'B/L Date', type: 'date-picker', required: false },
                {md: '3', id: 'invoice_number', label: 'Shipper Invoice Number', type: 'text-field', required: false },
                {md: '3', id: 'shipping_line', label: 'Shipping Line', type: 'text-field', required: false },
                {md: '3', id: 'volume', label: 'Volume', type: 'text-field', required: false },
                {md: '3', id: 'volume_equipment', label: 'Equipment', type: 'select', items: EQUIPMENT_TYPES, required: false },
                {md: '6', id: 'shipper', label: 'Shipper', type: 'text-field', required: false, validate: true},
                {md: '12', id: 'shipper_address', label: 'Shipper Address', type: 'textarea', required: false, validate: true},
                {md: '12', id: 'vessel_number', label: 'Vessel & Voyage #', type: 'text-field', required: false },
                {md: '6', id: 'port_of_loading', label: 'Port of Loading', type: 'text-field', required: true, validate: true},
                {md: '6', id: 'port_of_discharge', label: 'Port Of Discharge', type: 'text-field', required: true, validate: true},
                {md: '6', id: 'place_of_receipt', label: 'Place of Receipt', type: 'text-field', required: false},
                {md: '6', id: 'place_of_delivery', label: 'Place of Delivery', type: 'text-field', required: false},
                {md: '6', id: 'etd', label: 'Estimated Time of Departure (YYYY-MM-DD)', hint: 'From Origin', type: 'date-picker', required: false },
                {md: '6', id: 'eta', label: 'Estimated Time of Arrival (YYYY-MM-DD)', hint: 'At Destination', type: 'date-picker', required: false},
                // {md: '6', id: 'bill_of_lading', label: 'asd', type: 'text-field', required: false, validate: true, validateLength: true, counter: 10 },
                // {md: '6', id: 'bill_of_lading', label: 'asd', type: 'text-field', required: false, validate: true, validateLength: true, counter: 10 },

            ],
            items: [
                {
                    action: 'journey',
                    title: 'Journeys'
                },
                {
                    action: 'container',
                    title: 'Containers'
                },
                {
                    action: 'shipping_bill',
                    title: 'Shipping Bills'
                }
            ]
        }),
        computed: {
            ...mapState({'currentUser': 'user'}),
            isCreate() {
                return this.$route.params && this.$route.params.id != null && this.$route.params.id == 'create' ? true : false;
            },
            sectionTitle() {
                return this.isCreate ? 'Create Booking' : 'Booking Detail';
            },
            booking_id() {
                return this.isCreate ? '' : this.$route.params.id;
            },
            disabled() {
                return !this.isCreate && !this.edit_mode
            }
        },
        beforeMount() {
            this.loadBooking();
        },
        beforeRouteUpdate(to, from, next) {
            this.overlay = true
            next()
            this.loadBooking();
        },
        methods: {
            getRules(item) {
                let rules = [];
                if(item.validate) {
                    rules.push(v => !!v || `${item.label} is required`)
                }
                if(item.validateLength && item.counter > 0) {
                    rules.push(v => (!v || v.length <= item.counter) || `Must be less than ${item.counter} characters`)
                }
                if(item.customRules && item.customRules.length > 0){
                    rules = rules.concat(item.customRules)
                }
                return rules;
            },
            toggleEdit() {
              this.edit_mode = !this.edit_mode;
              this.edit_icon = this.edit_mode ? 'close' : 'create';
            },
            async fetchBooking({id}) {
                try {
                    const { data } = await BookingApi.getBookingDetails(id);
                    this.booking = data.Item;
                    this.overlay = false
                } catch (e) {
                    console.error('FETCH_BOOKING -> ', e)
                }
            },
            loadBooking() {
                if(!this.isCreate) {
                    return this.fetchBooking({id: this.booking_id});
                }
                this.overlay = false;
            },
            async saveBooking() {
                try {
                    this.overlay = true;
                    if(this.currentUser && this.currentUser.name){
                        this.booking.last_modified_by = this.currentUser.name;
                    }
                    if (this.isCreate) {
                        if(this.currentUser && this.currentUser.name){
                            this.booking.created_by = this.currentUser.name;
                        }
                        this.booking.booking_status = BOOKING_STATUS.INPROGRESS;
                        await BookingApi.addBooking(this.booking);
                        this.toggleSnackbar({color: 'success', text: 'Booking saved successfully'})
                        return this.$router.replace(this.booking.id);
                    }else {
                        await BookingApi.updateBooking(this.booking);
                        this.toggleSnackbar({color: 'success', text: 'Booking updated successfully'})
                    }
                } catch (e) {
                    this.toggleSnackbar({color: 'error',text: 'Error while saving the booking details'})
                }
                this.overlay = false

            },
            toggleSnackbar({color = 'info', text}) {
                this.snackbar_text = text;
                this.snackbar_color = color;
                this.snackbar = true
            },
            closeDatePicker(field) {
                this.dateTempHolder[field] = this.booking[field]
                return;
            },
            getDisplayDate(date) {
                return DateTimeHelper.getDisplayDate(date);
            }
        }
    }
</script>